<template>
  <div>

<b-container>
  <select id="officeT" class="dropDown60px" @change="goFunction()" style="z-index:1;">
    <option value="whoweare">Who We Are</option>
    <option value="regoffice">Registered Office</option>
    <option value="profile">Company Profile</option>
    <option value="glance">APDCL at a Glance</option>
    <option value="Mandate">Mandate of the company</option>
    <option value="vision">Our Vision</option>
    <option value="mission">Our Mission</option>
    <option value="minister">Ministers</option>
    <option value="bod">Board of Directors</option>
    <!-- <option value="chairmsg">Chairman's Message</option>
    <option value="mdmsg">MD's Message</option> -->
    <!-- <option value="jobchart">Job Chart and Responsibilities of<br> Key Officials</option> -->
    <option value="adminh">Administration Hierarchy</option>
    <option value="gmap">Geographical Map</option>
    <option value="pmap">Power Map</option>
    <option value="iso">ISO Certificate</option>
    <option value="qp">Quality Policy</option>
  </select>
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
    goFunction()
    {
      var ofc=document.getElementById('officeT').value;
    //  alert("Office::"+ofc);
    if(ofc == "iso"){
      window.location.href= "https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/ISO_Certificate.pdf"
    }
    else if( ofc == "qp"){
      window.location.href= "https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Quality_Policy.pdf"
    }
      this.goto(ofc);
    },

  goto(refName) {
  //   alert(refName);
     var element=document.getElementById(refName);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });

   }
  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;

 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd       ;
  border-color: #0277bd       ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1     ;
  border-color: #0288d1     ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}
@media (max-width: 768px) {
  .dropDown60px{
    margin-right: 60px;
  }
  }
</style>
